import template from "./spray_public_application_record.html";
import en from "./en.json";
import es from "./es.json";
import logoUrl from "../../../../../assets/harvust-logo-008.svg";
import _ from "lodash";
import {
    SPRAY_APPLICATION_RECORD_STATUSES,
    getSprayApplicationRecordStatusTextClass,
} from "../../constants";

class SprayPublicApplicationRecordController {
    /* @ngInject */
    constructor() {
        this.LOGO_URL = logoUrl;
    }

    $onInit() {
        let ctrl = this;
        ctrl.inProgressStatusClass = getSprayApplicationRecordStatusTextClass(
            SPRAY_APPLICATION_RECORD_STATUSES.IN_PROGRESS,
        );
        ctrl.fields = ctrl.applicationRecord.fields || [];
        ctrl.cropNames = _.uniq(
            _.flatten(
                _.map(ctrl.fields, function (field) {
                    return _.map(field.crops, "name");
                }),
            ),
        );

        ctrl.fieldsWithBoundaries = _.filter(ctrl.fields, function (field) {
            return ctrl.getValidShapePointCount(field) >= 3;
        });
        ctrl.showMap = ctrl.fieldsWithBoundaries.length > 0;
    }

    getValidShapePointCount(field) {
        return _.filter(_.get(field, "shape_json", []), function (point) {
            let latitude = Number(
                _.get(point, "latitude", _.get(point, "lat")),
            );
            let longitude = Number(
                _.get(point, "longitude", _.get(point, "lng")),
            );
            return Number.isFinite(latitude) && Number.isFinite(longitude);
        }).length;
    }
}

export default {
    name: "sprayPublicApplicationRecord",
    template: template,
    controller: SprayPublicApplicationRecordController,
    bindings: {
        applicationRecord: "<",
        neighbor: "<",
    },
    translations: { en, es },
};
